// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CollectionPreviewUrl,
    ObjectNoResponse,
    PatchUserPayload,
    RequestAccountAccessRequest,
    SettlementSchedule,
    SupportAccount,
    SupportAccountCreateEnterprisePayload,
    SupportAccountCreationResponse,
    SupportAccountEnterprise,
    SupportAccountGroupCreationResponse,
    SupportAccountRefreshResponse,
    SupportAccountSortType,
    SupportApplication,
    SupportCreateAccountGroupPayload,
    SupportCreateAccountPayload,
    SupportCreateAdminUserPayload,
    SupportCreateUserGrantPayload,
    SupportCreateUserPayload,
    SupportDebug,
    SupportDebugBackgroundRequest,
    SupportDebugRequest,
    SupportEditJobRequest,
    SupportJob,
    SupportReloadRedisApplicationRequest,
    SupportReloadRedisEmailRequest,
    SupportReloadRedisRequest,
    SupportReplayInboxWebhookRequest,
    SupportShortUrl,
    SupportUser,
    SupportUserGrant,
    TemporaryDocumentUrl,
    UpdateAccountMccPayload,
    UpdateChargeBankingAccountPayload,
    UpdateDepositBankingAccountPayload,
    UpdateMonitorBankingAccountPayload,
    PatchUserPayloadToJSON,
    RequestAccountAccessRequestToJSON,
    SettlementScheduleToJSON,
    SupportAccountCreateEnterprisePayloadToJSON,
    SupportCreateAccountGroupPayloadToJSON,
    SupportCreateAccountPayloadToJSON,
    SupportCreateAdminUserPayloadToJSON,
    SupportCreateUserGrantPayloadToJSON,
    SupportCreateUserPayloadToJSON,
    SupportDebugBackgroundRequestToJSON,
    SupportDebugRequestToJSON,
    SupportEditJobRequestToJSON,
    SupportReloadRedisApplicationRequestToJSON,
    SupportReloadRedisEmailRequestToJSON,
    SupportReloadRedisRequestToJSON,
    SupportReplayInboxWebhookRequestToJSON,
    UpdateAccountMccPayloadToJSON,
    UpdateChargeBankingAccountPayloadToJSON,
    UpdateDepositBankingAccountPayloadToJSON,
    UpdateMonitorBankingAccountPayloadToJSON,
    CollectionPreviewUrlFromJSON,
    ObjectNoResponseFromJSON,
    SupportAccountFromJSON,
    SupportAccountCreationResponseFromJSON,
    SupportAccountEnterpriseFromJSON,
    SupportAccountGroupCreationResponseFromJSON,
    SupportAccountRefreshResponseFromJSON,
    SupportApplicationFromJSON,
    SupportDebugFromJSON,
    SupportJobFromJSON,
    SupportShortUrlFromJSON,
    SupportUserFromJSON,
    SupportUserGrantFromJSON,
    TemporaryDocumentUrlFromJSON,
} from '../models';

export interface AdminPersonalProviderDashboardGrantAccountRequest {
    requestAccountAccessRequest: RequestAccountAccessRequest;
}

export interface AdminRemoveGrantAccountRequest {
    accountId: string;
}

export interface AdminSupportGrantAccountRequest {
    accountId: string;
}

export interface AllocateAccountCollectionPaymentsRequest {
    accountId: string;
}

export interface CalculateAccountCollectionRefundsRequest {
    accountId: string;
}

export interface CreateAccountBillingStripeAccountRequest {
    accountId: string;
}

export interface DisableSupportGrantRequest {
    userId: string;
    grantId: string;
}

export interface EditSupportJobRequest {
    jobId: string;
    supportEditJobRequest: SupportEditJobRequest;
}

export interface GenerateAccountCollectionSubmissionRequest {
    accountId: string;
}

export interface GetBankAccountSetupUrlRequest {
    accountId: string;
    transactionsOnly?: boolean;
}

export interface GetStripeSetupUrlRequest {
    accountId: string;
}

export interface GetSupportAccountRequest {
    accountId: string;
}

export interface GetSupportAccountEnterpriseRequest {
    accountId: string;
}

export interface GetSupportAccountListRequest {
    filterAccountType?: Array<string>;
    filterCreated?: Array<string>;
    filterId?: Array<string>;
    filterBusinessName?: Array<string>;
    order?: Array<GetSupportAccountListOrderEnum>;
    limit?: number;
    offset?: number;
    sort?: Array<SupportAccountSortType>;
}

export interface GetSupportAdminUserListRequest {
    limit?: number;
    offset?: number;
}

export interface GetSupportGrantRequest {
    grantId: string;
    userId: string;
}

export interface GetSupportJobRequest {
    jobId: string;
}

export interface GetSupportUserRequest {
    userId: string;
}

export interface GetSupportUserGrantListRequest {
    userId: string;
    filterActive?: string;
    limit?: number;
    offset?: number;
}

export interface GetSupportUserListRequest {
    limit?: number;
    offset?: number;
}

export interface OneTimeSupportJobRequest {
    jobId: string;
}

export interface PatchSupportUserRequest {
    userId: string;
    patchUserPayload: PatchUserPayload;
}

export interface PostScramblePhoneRequest {
    accountId: string;
    body: object;
}

export interface PostSupportAccountRequest {
    supportCreateAccountPayload: SupportCreateAccountPayload;
}

export interface PostSupportAccountEnterpriseRequest {
    accountId: string;
    supportAccountCreateEnterprisePayload: SupportAccountCreateEnterprisePayload;
}

export interface PostSupportAccountGroupRequest {
    supportCreateAccountGroupPayload: SupportCreateAccountGroupPayload;
}

export interface PostSupportAdminAuthApplicationReloadDataRequest {
    supportReloadRedisApplicationRequest: SupportReloadRedisApplicationRequest;
}

export interface PostSupportAdminAuthEmailReloadDataRequest {
    supportReloadRedisEmailRequest: SupportReloadRedisEmailRequest;
}

export interface PostSupportAdminAuthReloadDataRequest {
    supportReloadRedisRequest: SupportReloadRedisRequest;
}

export interface PostSupportAdminUserRequest {
    supportCreateAdminUserPayload: SupportCreateAdminUserPayload;
}

export interface PostSupportBackgroundDebugRequest {
    supportDebugBackgroundRequest: SupportDebugBackgroundRequest;
}

export interface PostSupportDebugRequest {
    supportDebugRequest: SupportDebugRequest;
}

export interface PostSupportDisablePaymentsRequest {
    accountId: string;
    body: object;
}

export interface PostSupportEnablePaymentsRequest {
    accountId: string;
    body: object;
}

export interface PostSupportGrantRequest {
    userId: string;
    supportCreateUserGrantPayload: SupportCreateUserGrantPayload;
}

export interface PostSupportReplayHeldEnterpriseRequest {
    id: string;
}

export interface PostSupportReplayInboxWebhookRequest {
    supportReplayInboxWebhookRequest: SupportReplayInboxWebhookRequest;
}

export interface PostSupportUserRequest {
    supportCreateUserPayload: SupportCreateUserPayload;
}

export interface PostUnscramblePhoneRequest {
    accountId: string;
    body: object;
}

export interface PreviewAccountCollectionSubmissionRequest {
    accountId: string;
}

export interface RefreshSetupStripeRequest {
    accountId: string;
}

export interface RunCollectionImportRequest {
    accountId: string;
}

export interface SubmitAccountCollectionSubmissionRequest {
    accountId: string;
}

export interface UpdateChargeBankingAccountRequest {
    accountId: string;
    updateChargeBankingAccountPayload: UpdateChargeBankingAccountPayload;
}

export interface UpdateDepositBankingAccountRequest {
    accountId: string;
    updateDepositBankingAccountPayload: UpdateDepositBankingAccountPayload;
}

export interface UpdateMonitorBankingAccountRequest {
    accountId: string;
    updateMonitorBankingAccountPayload: UpdateMonitorBankingAccountPayload;
}

export interface UpdateSupportAccountMccRequest {
    accountId: string;
    updateAccountMccPayload: UpdateAccountMccPayload;
}

export interface UpdateSupportAccountSettlementScheduleRequest {
    accountId: string;
    settlementSchedule: SettlementSchedule;
}

/**
 * no description
 */
export class AdminApi extends runtime.BaseAPI {

    /**
     * Personal grant yourself access to this company\'s provider dashboard
     * Personal grant yourself access to this company\'s provider dashboard
     */
    async adminPersonalProviderDashboardGrantAccountRaw(requestParameters: AdminPersonalProviderDashboardGrantAccountRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['requestAccountAccessRequest'] === null || requestParameters['requestAccountAccessRequest'] === undefined) {
            throw new runtime.RequiredError('requestAccountAccessRequest','Required parameter requestParameters.requestAccountAccessRequest was null or undefined when calling adminPersonalProviderDashboardGrantAccount.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/me/personal_provider_dashboard_grant`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestAccountAccessRequestToJSON(requestParameters['requestAccountAccessRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Personal grant yourself access to this company\'s provider dashboard
     * Personal grant yourself access to this company\'s provider dashboard
     */
    async adminPersonalProviderDashboardGrantAccount(requestParameters: AdminPersonalProviderDashboardGrantAccountRequest): Promise<ObjectNoResponse> {
        const response = await this.adminPersonalProviderDashboardGrantAccountRaw(requestParameters);
        return await response.value();
    }

    /**
     * Admin grant
     * Admin Remove Grant account
     */
    async adminRemoveGrantAccountRaw(requestParameters: AdminRemoveGrantAccountRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling adminRemoveGrantAccount.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/admin_remove_grant`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Admin grant
     * Admin Remove Grant account
     */
    async adminRemoveGrantAccount(requestParameters: AdminRemoveGrantAccountRequest): Promise<ObjectNoResponse> {
        const response = await this.adminRemoveGrantAccountRaw(requestParameters);
        return await response.value();
    }

    /**
     * Admin grant
     * Admin Grant account
     */
    async adminSupportGrantAccountRaw(requestParameters: AdminSupportGrantAccountRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling adminSupportGrantAccount.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/admin_support_grant`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Admin grant
     * Admin Grant account
     */
    async adminSupportGrantAccount(requestParameters: AdminSupportGrantAccountRequest): Promise<ObjectNoResponse> {
        const response = await this.adminSupportGrantAccountRaw(requestParameters);
        return await response.value();
    }

    /**
     * Allocate payments for collections submission
     * Allocate payments for collections submission
     */
    async allocateAccountCollectionPaymentsRaw(requestParameters: AllocateAccountCollectionPaymentsRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling allocateAccountCollectionPayments.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "update:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/collections/allocate_payments`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Allocate payments for collections submission
     * Allocate payments for collections submission
     */
    async allocateAccountCollectionPayments(requestParameters: AllocateAccountCollectionPaymentsRequest): Promise<ObjectNoResponse> {
        const response = await this.allocateAccountCollectionPaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Calculate collection refunds for account
     * Calculate collection refunds for account
     */
    async calculateAccountCollectionRefundsRaw(requestParameters: CalculateAccountCollectionRefundsRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling calculateAccountCollectionRefunds.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "update:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/collections/calculate_refunds`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Calculate collection refunds for account
     * Calculate collection refunds for account
     */
    async calculateAccountCollectionRefunds(requestParameters: CalculateAccountCollectionRefundsRequest): Promise<ObjectNoResponse> {
        const response = await this.calculateAccountCollectionRefundsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create the stripe billing account
     * Create the stripe billing account
     */
    async createAccountBillingStripeAccountRaw(requestParameters: CreateAccountBillingStripeAccountRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling createAccountBillingStripeAccount.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "update:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/billing_stripe_account`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Create the stripe billing account
     * Create the stripe billing account
     */
    async createAccountBillingStripeAccount(requestParameters: CreateAccountBillingStripeAccountRequest): Promise<ObjectNoResponse> {
        const response = await this.createAccountBillingStripeAccountRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a grant
     * Disable the grant
     */
    async disableSupportGrantRaw(requestParameters: DisableSupportGrantRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['userId'] === null || requestParameters['userId'] === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling disableSupportGrant.');
        }

        if (requestParameters['grantId'] === null || requestParameters['grantId'] === undefined) {
            throw new runtime.RequiredError('grantId','Required parameter requestParameters.grantId was null or undefined when calling disableSupportGrant.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "delete:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/user/{userId}/grant/{grantId}/disable`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"grantId"}}`, encodeURIComponent(String(requestParameters.grantId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a grant
     * Disable the grant
     */
    async disableSupportGrant(requestParameters: DisableSupportGrantRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportGrantRaw(requestParameters);
        return await response.value();
    }

    /**
     * Edit a support job
     * Edit a job
     */
    async editSupportJobRaw(requestParameters: EditSupportJobRequest): Promise<runtime.ApiResponse<SupportJob>> {
        if (requestParameters['jobId'] === null || requestParameters['jobId'] === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling editSupportJob.');
        }

        if (requestParameters['supportEditJobRequest'] === null || requestParameters['supportEditJobRequest'] === undefined) {
            throw new runtime.RequiredError('supportEditJobRequest','Required parameter requestParameters.supportEditJobRequest was null or undefined when calling editSupportJob.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:application"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/job/{jobId}`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportEditJobRequestToJSON(requestParameters['supportEditJobRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportJobFromJSON(jsonValue));
    }

    /**
     * Edit a support job
     * Edit a job
     */
    async editSupportJob(requestParameters: EditSupportJobRequest): Promise<SupportJob> {
        const response = await this.editSupportJobRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generate a collections submission
     * Generate a collections submission
     */
    async generateAccountCollectionSubmissionRaw(requestParameters: GenerateAccountCollectionSubmissionRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling generateAccountCollectionSubmission.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "update:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/collections/generate_submission`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Generate a collections submission
     * Generate a collections submission
     */
    async generateAccountCollectionSubmission(requestParameters: GenerateAccountCollectionSubmissionRequest): Promise<ObjectNoResponse> {
        const response = await this.generateAccountCollectionSubmissionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get bank account setup url
     * Get bank account setup url
     */
    async getBankAccountSetupUrlRaw(requestParameters: GetBankAccountSetupUrlRequest): Promise<runtime.ApiResponse<SupportShortUrl>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling getBankAccountSetupUrl.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.transactionsOnly !== undefined) {
            queryParameters['transactionsOnly'] = requestParameters.transactionsOnly;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/bank_account_setup_url`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportShortUrlFromJSON(jsonValue));
    }

    /**
     * Get bank account setup url
     * Get bank account setup url
     */
    async getBankAccountSetupUrl(requestParameters: GetBankAccountSetupUrlRequest): Promise<SupportShortUrl> {
        const response = await this.getBankAccountSetupUrlRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get stripe setup url
     * Get stripe setup url
     */
    async getStripeSetupUrlRaw(requestParameters: GetStripeSetupUrlRequest): Promise<runtime.ApiResponse<SupportShortUrl>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling getStripeSetupUrl.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/stripe_setup_url`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportShortUrlFromJSON(jsonValue));
    }

    /**
     * Get stripe setup url
     * Get stripe setup url
     */
    async getStripeSetupUrl(requestParameters: GetStripeSetupUrlRequest): Promise<SupportShortUrl> {
        const response = await this.getStripeSetupUrlRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a single account
     * Get a single account
     */
    async getSupportAccountRaw(requestParameters: GetSupportAccountRequest): Promise<runtime.ApiResponse<SupportAccount>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling getSupportAccount.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAccountFromJSON(jsonValue));
    }

    /**
     * Get a single account
     * Get a single account
     */
    async getSupportAccount(requestParameters: GetSupportAccountRequest): Promise<SupportAccount> {
        const response = await this.getSupportAccountRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get enterprise for collections
     * Get enterprise for collections
     */
    async getSupportAccountEnterpriseRaw(requestParameters: GetSupportAccountEnterpriseRequest): Promise<runtime.ApiResponse<SupportAccountEnterprise>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling getSupportAccountEnterprise.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/enterprise`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAccountEnterpriseFromJSON(jsonValue));
    }

    /**
     * Get enterprise for collections
     * Get enterprise for collections
     */
    async getSupportAccountEnterprise(requestParameters: GetSupportAccountEnterpriseRequest): Promise<SupportAccountEnterprise> {
        const response = await this.getSupportAccountEnterpriseRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a list of all accounts in the system
     * Get a list of all accounts in the system
     */
    async getSupportAccountListRaw(requestParameters: GetSupportAccountListRequest): Promise<runtime.ApiResponse<Array<SupportAccount>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterAccountType) {
            queryParameters['filterAccountType'] = requestParameters.filterAccountType;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.filterBusinessName) {
            queryParameters['filterBusinessName'] = requestParameters.filterBusinessName;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportAccountFromJSON));
    }

    /**
     * Get a list of all accounts in the system
     * Get a list of all accounts in the system
     */
    async getSupportAccountList(requestParameters: GetSupportAccountListRequest): Promise<Array<SupportAccount>> {
        const response = await this.getSupportAccountListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a list of all users in the system
     * Get a list of all users in the system
     */
    async getSupportAdminUserListRaw(requestParameters: GetSupportAdminUserListRequest): Promise<runtime.ApiResponse<Array<SupportUser>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/admin_user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportUserFromJSON));
    }

    /**
     * Get a list of all users in the system
     * Get a list of all users in the system
     */
    async getSupportAdminUserList(requestParameters: GetSupportAdminUserListRequest): Promise<Array<SupportUser>> {
        const response = await this.getSupportAdminUserListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a single user grant
     * Get a single user grant
     */
    async getSupportGrantRaw(requestParameters: GetSupportGrantRequest): Promise<runtime.ApiResponse<SupportUserGrant>> {
        if (requestParameters['grantId'] === null || requestParameters['grantId'] === undefined) {
            throw new runtime.RequiredError('grantId','Required parameter requestParameters.grantId was null or undefined when calling getSupportGrant.');
        }

        if (requestParameters['userId'] === null || requestParameters['userId'] === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getSupportGrant.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/user/{userId}/grant/{grantId}`.replace(`{${"grantId"}}`, encodeURIComponent(String(requestParameters.grantId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportUserGrantFromJSON(jsonValue));
    }

    /**
     * Get a single user grant
     * Get a single user grant
     */
    async getSupportGrant(requestParameters: GetSupportGrantRequest): Promise<SupportUserGrant> {
        const response = await this.getSupportGrantRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a support job
     * Get a job
     */
    async getSupportJobRaw(requestParameters: GetSupportJobRequest): Promise<runtime.ApiResponse<SupportJob>> {
        if (requestParameters['jobId'] === null || requestParameters['jobId'] === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling getSupportJob.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:application"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/job/{jobId}`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportJobFromJSON(jsonValue));
    }

    /**
     * Gets a support job
     * Get a job
     */
    async getSupportJob(requestParameters: GetSupportJobRequest): Promise<SupportJob> {
        const response = await this.getSupportJobRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a single user
     * Get a single user
     */
    async getSupportUserRaw(requestParameters: GetSupportUserRequest): Promise<runtime.ApiResponse<SupportUser>> {
        if (requestParameters['userId'] === null || requestParameters['userId'] === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getSupportUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/user/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportUserFromJSON(jsonValue));
    }

    /**
     * Get a single user
     * Get a single user
     */
    async getSupportUser(requestParameters: GetSupportUserRequest): Promise<SupportUser> {
        const response = await this.getSupportUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a list of a user\'s grants in the system
     * Get a list of a user\'s grants in the system
     */
    async getSupportUserGrantListRaw(requestParameters: GetSupportUserGrantListRequest): Promise<runtime.ApiResponse<Array<SupportUserGrant>>> {
        if (requestParameters['userId'] === null || requestParameters['userId'] === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getSupportUserGrantList.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/user/{userId}/grant`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportUserGrantFromJSON));
    }

    /**
     * Get a list of a user\'s grants in the system
     * Get a list of a user\'s grants in the system
     */
    async getSupportUserGrantList(requestParameters: GetSupportUserGrantListRequest): Promise<Array<SupportUserGrant>> {
        const response = await this.getSupportUserGrantListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a list of all users in the system
     * Get a list of all users in the system
     */
    async getSupportUserListRaw(requestParameters: GetSupportUserListRequest): Promise<runtime.ApiResponse<Array<SupportUser>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportUserFromJSON));
    }

    /**
     * Get a list of all users in the system
     * Get a list of all users in the system
     */
    async getSupportUserList(requestParameters: GetSupportUserListRequest): Promise<Array<SupportUser>> {
        const response = await this.getSupportUserListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of applications
     * Get a list of applications
     */
    async listSupportApplicationsRaw(): Promise<runtime.ApiResponse<Array<SupportApplication>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:application"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/application`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportApplicationFromJSON));
    }

    /**
     * Gets a list of applications
     * Get a list of applications
     */
    async listSupportApplications(): Promise<Array<SupportApplication>> {
        const response = await this.listSupportApplicationsRaw();
        return await response.value();
    }

    /**
     * Gets a list of jobs
     * Get a list of jobs
     */
    async listSupportJobsRaw(): Promise<runtime.ApiResponse<Array<SupportJob>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:application"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/job`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportJobFromJSON));
    }

    /**
     * Gets a list of jobs
     * Get a list of jobs
     */
    async listSupportJobs(): Promise<Array<SupportJob>> {
        const response = await this.listSupportJobsRaw();
        return await response.value();
    }

    /**
     * Create a one-time execution of a job
     * Create a one-time execution of a job
     */
    async oneTimeSupportJobRaw(requestParameters: OneTimeSupportJobRequest): Promise<runtime.ApiResponse<SupportJob>> {
        if (requestParameters['jobId'] === null || requestParameters['jobId'] === undefined) {
            throw new runtime.RequiredError('jobId','Required parameter requestParameters.jobId was null or undefined when calling oneTimeSupportJob.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:application"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/job/{jobId}/one_time`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportJobFromJSON(jsonValue));
    }

    /**
     * Create a one-time execution of a job
     * Create a one-time execution of a job
     */
    async oneTimeSupportJob(requestParameters: OneTimeSupportJobRequest): Promise<SupportJob> {
        const response = await this.oneTimeSupportJobRaw(requestParameters);
        return await response.value();
    }

    /**
     * Patch properties on a single user
     * Patch properties on a single user
     */
    async patchSupportUserRaw(requestParameters: PatchSupportUserRequest): Promise<runtime.ApiResponse<SupportUser>> {
        if (requestParameters['userId'] === null || requestParameters['userId'] === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling patchSupportUser.');
        }

        if (requestParameters['patchUserPayload'] === null || requestParameters['patchUserPayload'] === undefined) {
            throw new runtime.RequiredError('patchUserPayload','Required parameter requestParameters.patchUserPayload was null or undefined when calling patchSupportUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "update:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/user/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchUserPayloadToJSON(requestParameters['patchUserPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportUserFromJSON(jsonValue));
    }

    /**
     * Patch properties on a single user
     * Patch properties on a single user
     */
    async patchSupportUser(requestParameters: PatchSupportUserRequest): Promise<SupportUser> {
        const response = await this.patchSupportUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Unscramble phone
     * Unscramble phone
     */
    async postScramblePhoneRaw(requestParameters: PostScramblePhoneRequest): Promise<runtime.ApiResponse<SupportAccount>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling postScramblePhone.');
        }

        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postScramblePhone.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/phone_scramble`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAccountFromJSON(jsonValue));
    }

    /**
     * Unscramble phone
     * Unscramble phone
     */
    async postScramblePhone(requestParameters: PostScramblePhoneRequest): Promise<SupportAccount> {
        const response = await this.postScramblePhoneRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create new master account
     * Create new master account
     */
    async postSupportAccountRaw(requestParameters: PostSupportAccountRequest): Promise<runtime.ApiResponse<SupportAccountCreationResponse>> {
        if (requestParameters['supportCreateAccountPayload'] === null || requestParameters['supportCreateAccountPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateAccountPayload','Required parameter requestParameters.supportCreateAccountPayload was null or undefined when calling postSupportAccount.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support:grant", "support", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateAccountPayloadToJSON(requestParameters['supportCreateAccountPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAccountCreationResponseFromJSON(jsonValue));
    }

    /**
     * Create new master account
     * Create new master account
     */
    async postSupportAccount(requestParameters: PostSupportAccountRequest): Promise<SupportAccountCreationResponse> {
        const response = await this.postSupportAccountRaw(requestParameters);
        return await response.value();
    }

    /**
     * Activate enterprise for collections
     * Activate enterprise for collections
     */
    async postSupportAccountEnterpriseRaw(requestParameters: PostSupportAccountEnterpriseRequest): Promise<runtime.ApiResponse<SupportAccountEnterprise>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling postSupportAccountEnterprise.');
        }

        if (requestParameters['supportAccountCreateEnterprisePayload'] === null || requestParameters['supportAccountCreateEnterprisePayload'] === undefined) {
            throw new runtime.RequiredError('supportAccountCreateEnterprisePayload','Required parameter requestParameters.supportAccountCreateEnterprisePayload was null or undefined when calling postSupportAccountEnterprise.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/enterprise`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportAccountCreateEnterprisePayloadToJSON(requestParameters['supportAccountCreateEnterprisePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAccountEnterpriseFromJSON(jsonValue));
    }

    /**
     * Activate enterprise for collections
     * Activate enterprise for collections
     */
    async postSupportAccountEnterprise(requestParameters: PostSupportAccountEnterpriseRequest): Promise<SupportAccountEnterprise> {
        const response = await this.postSupportAccountEnterpriseRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create new account group
     * Create new account group
     */
    async postSupportAccountGroupRaw(requestParameters: PostSupportAccountGroupRequest): Promise<runtime.ApiResponse<SupportAccountGroupCreationResponse>> {
        if (requestParameters['supportCreateAccountGroupPayload'] === null || requestParameters['supportCreateAccountGroupPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateAccountGroupPayload','Required parameter requestParameters.supportCreateAccountGroupPayload was null or undefined when calling postSupportAccountGroup.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support:grant", "support", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account_group`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateAccountGroupPayloadToJSON(requestParameters['supportCreateAccountGroupPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAccountGroupCreationResponseFromJSON(jsonValue));
    }

    /**
     * Create new account group
     * Create new account group
     */
    async postSupportAccountGroup(requestParameters: PostSupportAccountGroupRequest): Promise<SupportAccountGroupCreationResponse> {
        const response = await this.postSupportAccountGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     * Reload auth data to Redis
     * Reload auth data to Redis
     */
    async postSupportAdminAuthApplicationReloadDataRaw(requestParameters: PostSupportAdminAuthApplicationReloadDataRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReloadRedisApplicationRequest'] === null || requestParameters['supportReloadRedisApplicationRequest'] === undefined) {
            throw new runtime.RequiredError('supportReloadRedisApplicationRequest','Required parameter requestParameters.supportReloadRedisApplicationRequest was null or undefined when calling postSupportAdminAuthApplicationReloadData.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support:grant", "support", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/auth/reload_application_data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReloadRedisApplicationRequestToJSON(requestParameters['supportReloadRedisApplicationRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Reload auth data to Redis
     * Reload auth data to Redis
     */
    async postSupportAdminAuthApplicationReloadData(requestParameters: PostSupportAdminAuthApplicationReloadDataRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportAdminAuthApplicationReloadDataRaw(requestParameters);
        return await response.value();
    }

    /**
     * Reload auth data to Redis
     * Reload auth data to Redis
     */
    async postSupportAdminAuthEmailReloadDataRaw(requestParameters: PostSupportAdminAuthEmailReloadDataRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReloadRedisEmailRequest'] === null || requestParameters['supportReloadRedisEmailRequest'] === undefined) {
            throw new runtime.RequiredError('supportReloadRedisEmailRequest','Required parameter requestParameters.supportReloadRedisEmailRequest was null or undefined when calling postSupportAdminAuthEmailReloadData.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support:grant", "support", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/auth/reload_email_data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReloadRedisEmailRequestToJSON(requestParameters['supportReloadRedisEmailRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Reload auth data to Redis
     * Reload auth data to Redis
     */
    async postSupportAdminAuthEmailReloadData(requestParameters: PostSupportAdminAuthEmailReloadDataRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportAdminAuthEmailReloadDataRaw(requestParameters);
        return await response.value();
    }

    /**
     * Reload auth data to Redis
     * Reload auth data to Redis
     */
    async postSupportAdminAuthReloadDataRaw(requestParameters: PostSupportAdminAuthReloadDataRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReloadRedisRequest'] === null || requestParameters['supportReloadRedisRequest'] === undefined) {
            throw new runtime.RequiredError('supportReloadRedisRequest','Required parameter requestParameters.supportReloadRedisRequest was null or undefined when calling postSupportAdminAuthReloadData.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support:grant", "support", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/auth/reload_data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReloadRedisRequestToJSON(requestParameters['supportReloadRedisRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Reload auth data to Redis
     * Reload auth data to Redis
     */
    async postSupportAdminAuthReloadData(requestParameters: PostSupportAdminAuthReloadDataRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportAdminAuthReloadDataRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an admin user
     * Create an admin user
     */
    async postSupportAdminUserRaw(requestParameters: PostSupportAdminUserRequest): Promise<runtime.ApiResponse<SupportUser>> {
        if (requestParameters['supportCreateAdminUserPayload'] === null || requestParameters['supportCreateAdminUserPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateAdminUserPayload','Required parameter requestParameters.supportCreateAdminUserPayload was null or undefined when calling postSupportAdminUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "create:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/admin_user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateAdminUserPayloadToJSON(requestParameters['supportCreateAdminUserPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportUserFromJSON(jsonValue));
    }

    /**
     * Create an admin user
     * Create an admin user
     */
    async postSupportAdminUser(requestParameters: PostSupportAdminUserRequest): Promise<SupportUser> {
        const response = await this.postSupportAdminUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generates debug information
     * Generates debug information
     */
    async postSupportBackgroundDebugRaw(requestParameters: PostSupportBackgroundDebugRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['supportDebugBackgroundRequest'] === null || requestParameters['supportDebugBackgroundRequest'] === undefined) {
            throw new runtime.RequiredError('supportDebugBackgroundRequest','Required parameter requestParameters.supportDebugBackgroundRequest was null or undefined when calling postSupportBackgroundDebug.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/debug_background`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportDebugBackgroundRequestToJSON(requestParameters['supportDebugBackgroundRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Generates debug information
     * Generates debug information
     */
    async postSupportBackgroundDebug(requestParameters: PostSupportBackgroundDebugRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.postSupportBackgroundDebugRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets debug information
     * Gets debug information
     */
    async postSupportDebugRaw(requestParameters: PostSupportDebugRequest): Promise<runtime.ApiResponse<SupportDebug>> {
        if (requestParameters['supportDebugRequest'] === null || requestParameters['supportDebugRequest'] === undefined) {
            throw new runtime.RequiredError('supportDebugRequest','Required parameter requestParameters.supportDebugRequest was null or undefined when calling postSupportDebug.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/debug`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportDebugRequestToJSON(requestParameters['supportDebugRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDebugFromJSON(jsonValue));
    }

    /**
     * Gets debug information
     * Gets debug information
     */
    async postSupportDebug(requestParameters: PostSupportDebugRequest): Promise<SupportDebug> {
        const response = await this.postSupportDebugRaw(requestParameters);
        return await response.value();
    }

    /**
     * Activate account
     * Activate account
     */
    async postSupportDisablePaymentsRaw(requestParameters: PostSupportDisablePaymentsRequest): Promise<runtime.ApiResponse<SupportAccount>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling postSupportDisablePayments.');
        }

        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postSupportDisablePayments.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/disable_payments`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAccountFromJSON(jsonValue));
    }

    /**
     * Activate account
     * Activate account
     */
    async postSupportDisablePayments(requestParameters: PostSupportDisablePaymentsRequest): Promise<SupportAccount> {
        const response = await this.postSupportDisablePaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Activate account
     * Activate account
     */
    async postSupportEnablePaymentsRaw(requestParameters: PostSupportEnablePaymentsRequest): Promise<runtime.ApiResponse<SupportAccount>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling postSupportEnablePayments.');
        }

        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postSupportEnablePayments.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/enable_payments`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAccountFromJSON(jsonValue));
    }

    /**
     * Activate account
     * Activate account
     */
    async postSupportEnablePayments(requestParameters: PostSupportEnablePaymentsRequest): Promise<SupportAccount> {
        const response = await this.postSupportEnablePaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a grant for a user
     * Create a grant for a user
     */
    async postSupportGrantRaw(requestParameters: PostSupportGrantRequest): Promise<runtime.ApiResponse<SupportUserGrant>> {
        if (requestParameters['userId'] === null || requestParameters['userId'] === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling postSupportGrant.');
        }

        if (requestParameters['supportCreateUserGrantPayload'] === null || requestParameters['supportCreateUserGrantPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateUserGrantPayload','Required parameter requestParameters.supportCreateUserGrantPayload was null or undefined when calling postSupportGrant.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "create:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/user/{userId}/grant`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateUserGrantPayloadToJSON(requestParameters['supportCreateUserGrantPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportUserGrantFromJSON(jsonValue));
    }

    /**
     * Create a grant for a user
     * Create a grant for a user
     */
    async postSupportGrant(requestParameters: PostSupportGrantRequest): Promise<SupportUserGrant> {
        const response = await this.postSupportGrantRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replay held webhooks for enterprise
     * Replay held webhooks for enterprise
     */
    async postSupportReplayHeldEnterpriseRaw(requestParameters: PostSupportReplayHeldEnterpriseRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportReplayHeldEnterprise.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/inbox_enterprise/{id}/replay_held`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replay held webhooks for enterprise
     * Replay held webhooks for enterprise
     */
    async postSupportReplayHeldEnterprise(requestParameters: PostSupportReplayHeldEnterpriseRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportReplayHeldEnterpriseRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets debug information
     * Gets debug information
     */
    async postSupportReplayInboxWebhookRaw(requestParameters: PostSupportReplayInboxWebhookRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReplayInboxWebhookRequest'] === null || requestParameters['supportReplayInboxWebhookRequest'] === undefined) {
            throw new runtime.RequiredError('supportReplayInboxWebhookRequest','Required parameter requestParameters.supportReplayInboxWebhookRequest was null or undefined when calling postSupportReplayInboxWebhook.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/replay_inbox_webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReplayInboxWebhookRequestToJSON(requestParameters['supportReplayInboxWebhookRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Gets debug information
     * Gets debug information
     */
    async postSupportReplayInboxWebhook(requestParameters: PostSupportReplayInboxWebhookRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportReplayInboxWebhookRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a user
     * Create a user
     */
    async postSupportUserRaw(requestParameters: PostSupportUserRequest): Promise<runtime.ApiResponse<SupportUser>> {
        if (requestParameters['supportCreateUserPayload'] === null || requestParameters['supportCreateUserPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateUserPayload','Required parameter requestParameters.supportCreateUserPayload was null or undefined when calling postSupportUser.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "create:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateUserPayloadToJSON(requestParameters['supportCreateUserPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportUserFromJSON(jsonValue));
    }

    /**
     * Create a user
     * Create a user
     */
    async postSupportUser(requestParameters: PostSupportUserRequest): Promise<SupportUser> {
        const response = await this.postSupportUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Scramble phone
     * Scramble phone
     */
    async postUnscramblePhoneRaw(requestParameters: PostUnscramblePhoneRequest): Promise<runtime.ApiResponse<SupportAccount>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling postUnscramblePhone.');
        }

        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postUnscramblePhone.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/phone_unscramble`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAccountFromJSON(jsonValue));
    }

    /**
     * Scramble phone
     * Scramble phone
     */
    async postUnscramblePhone(requestParameters: PostUnscramblePhoneRequest): Promise<SupportAccount> {
        const response = await this.postUnscramblePhoneRaw(requestParameters);
        return await response.value();
    }

    /**
     * Preview a collections submission
     * Preview a collections submission
     */
    async previewAccountCollectionSubmissionRaw(requestParameters: PreviewAccountCollectionSubmissionRequest): Promise<runtime.ApiResponse<CollectionPreviewUrl>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling previewAccountCollectionSubmission.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "update:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/collections/preview_submission`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CollectionPreviewUrlFromJSON(jsonValue));
    }

    /**
     * Preview a collections submission
     * Preview a collections submission
     */
    async previewAccountCollectionSubmission(requestParameters: PreviewAccountCollectionSubmissionRequest): Promise<CollectionPreviewUrl> {
        const response = await this.previewAccountCollectionSubmissionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get stripe setup url
     * Get stripe setup url
     */
    async refreshSetupStripeRaw(requestParameters: RefreshSetupStripeRequest): Promise<runtime.ApiResponse<SupportAccountRefreshResponse>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling refreshSetupStripe.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "read:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/refresh_stripe_setup`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAccountRefreshResponseFromJSON(jsonValue));
    }

    /**
     * Get stripe setup url
     * Get stripe setup url
     */
    async refreshSetupStripe(requestParameters: RefreshSetupStripeRequest): Promise<SupportAccountRefreshResponse> {
        const response = await this.refreshSetupStripeRaw(requestParameters);
        return await response.value();
    }

    /**
     * Run collection import for the account
     * Run collection import for the account
     */
    async runCollectionImportRaw(requestParameters: RunCollectionImportRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling runCollectionImport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "update:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/collections/run_collection_import`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Run collection import for the account
     * Run collection import for the account
     */
    async runCollectionImport(requestParameters: RunCollectionImportRequest): Promise<ObjectNoResponse> {
        const response = await this.runCollectionImportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Submit a collections submission
     * Submit a collections submission
     */
    async submitAccountCollectionSubmissionRaw(requestParameters: SubmitAccountCollectionSubmissionRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling submitAccountCollectionSubmission.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "update:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/collections/submit_submission`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Submit a collections submission
     * Submit a collections submission
     */
    async submitAccountCollectionSubmission(requestParameters: SubmitAccountCollectionSubmissionRequest): Promise<ObjectNoResponse> {
        const response = await this.submitAccountCollectionSubmissionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a single account charge banking account
     * Update a single account charge banking account
     */
    async updateChargeBankingAccountRaw(requestParameters: UpdateChargeBankingAccountRequest): Promise<runtime.ApiResponse<SupportAccount>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling updateChargeBankingAccount.');
        }

        if (requestParameters['updateChargeBankingAccountPayload'] === null || requestParameters['updateChargeBankingAccountPayload'] === undefined) {
            throw new runtime.RequiredError('updateChargeBankingAccountPayload','Required parameter requestParameters.updateChargeBankingAccountPayload was null or undefined when calling updateChargeBankingAccount.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "update:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/charge_banking_account`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateChargeBankingAccountPayloadToJSON(requestParameters['updateChargeBankingAccountPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAccountFromJSON(jsonValue));
    }

    /**
     * Update a single account charge banking account
     * Update a single account charge banking account
     */
    async updateChargeBankingAccount(requestParameters: UpdateChargeBankingAccountRequest): Promise<SupportAccount> {
        const response = await this.updateChargeBankingAccountRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a single account deposit banking account
     * Update a single account deposit banking account
     */
    async updateDepositBankingAccountRaw(requestParameters: UpdateDepositBankingAccountRequest): Promise<runtime.ApiResponse<SupportAccount>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling updateDepositBankingAccount.');
        }

        if (requestParameters['updateDepositBankingAccountPayload'] === null || requestParameters['updateDepositBankingAccountPayload'] === undefined) {
            throw new runtime.RequiredError('updateDepositBankingAccountPayload','Required parameter requestParameters.updateDepositBankingAccountPayload was null or undefined when calling updateDepositBankingAccount.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "update:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/deposit_banking_account`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDepositBankingAccountPayloadToJSON(requestParameters['updateDepositBankingAccountPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAccountFromJSON(jsonValue));
    }

    /**
     * Update a single account deposit banking account
     * Update a single account deposit banking account
     */
    async updateDepositBankingAccount(requestParameters: UpdateDepositBankingAccountRequest): Promise<SupportAccount> {
        const response = await this.updateDepositBankingAccountRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a single account deposit banking account
     * Update a single account deposit banking account
     */
    async updateMonitorBankingAccountRaw(requestParameters: UpdateMonitorBankingAccountRequest): Promise<runtime.ApiResponse<SupportAccount>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling updateMonitorBankingAccount.');
        }

        if (requestParameters['updateMonitorBankingAccountPayload'] === null || requestParameters['updateMonitorBankingAccountPayload'] === undefined) {
            throw new runtime.RequiredError('updateMonitorBankingAccountPayload','Required parameter requestParameters.updateMonitorBankingAccountPayload was null or undefined when calling updateMonitorBankingAccount.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "update:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/monitor_banking_account`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMonitorBankingAccountPayloadToJSON(requestParameters['updateMonitorBankingAccountPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAccountFromJSON(jsonValue));
    }

    /**
     * Update a single account deposit banking account
     * Update a single account deposit banking account
     */
    async updateMonitorBankingAccount(requestParameters: UpdateMonitorBankingAccountRequest): Promise<SupportAccount> {
        const response = await this.updateMonitorBankingAccountRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update the mcc used for a business
     * Update the mcc used for a business
     */
    async updateSupportAccountMccRaw(requestParameters: UpdateSupportAccountMccRequest): Promise<runtime.ApiResponse<SupportAccount>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling updateSupportAccountMcc.');
        }

        if (requestParameters['updateAccountMccPayload'] === null || requestParameters['updateAccountMccPayload'] === undefined) {
            throw new runtime.RequiredError('updateAccountMccPayload','Required parameter requestParameters.updateAccountMccPayload was null or undefined when calling updateSupportAccountMcc.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "update:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/update_mcc`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAccountMccPayloadToJSON(requestParameters['updateAccountMccPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAccountFromJSON(jsonValue));
    }

    /**
     * Update the mcc used for a business
     * Update the mcc used for a business
     */
    async updateSupportAccountMcc(requestParameters: UpdateSupportAccountMccRequest): Promise<SupportAccount> {
        const response = await this.updateSupportAccountMccRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a single account settlement schedule
     * Update a single account settlement schedule
     */
    async updateSupportAccountSettlementScheduleRaw(requestParameters: UpdateSupportAccountSettlementScheduleRequest): Promise<runtime.ApiResponse<SupportAccount>> {
        if (requestParameters['accountId'] === null || requestParameters['accountId'] === undefined) {
            throw new runtime.RequiredError('accountId','Required parameter requestParameters.accountId was null or undefined when calling updateSupportAccountSettlementSchedule.');
        }

        if (requestParameters['settlementSchedule'] === null || requestParameters['settlementSchedule'] === undefined) {
            throw new runtime.RequiredError('settlementSchedule','Required parameter requestParameters.settlementSchedule was null or undefined when calling updateSupportAccountSettlementSchedule.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "support:grant", "update:user"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/admin/account/{accountId}/settlement_schedule`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters.accountId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SettlementScheduleToJSON(requestParameters['settlementSchedule']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportAccountFromJSON(jsonValue));
    }

    /**
     * Update a single account settlement schedule
     * Update a single account settlement schedule
     */
    async updateSupportAccountSettlementSchedule(requestParameters: UpdateSupportAccountSettlementScheduleRequest): Promise<SupportAccount> {
        const response = await this.updateSupportAccountSettlementScheduleRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum GetSupportAccountListOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
